export enum Bidder {
  aol = 'aol',
  audienceNetwork = 'audienceNetwork',
  appnexus = 'appnexus',
  appnexusAst = 'appnexusAst',
  emx = 'emx_digital',
  google = 'google',
  gumgum = 'gumgum',
  indexExchange = 'indexExchange',
  openx = 'openx',
  pubmatic = 'pubmatic',
  roundel = 'roundel',
  rubicon = 'rubicon',
  triplelift = 'triplelift',
  uam = 'amazon',
  yieldmo = 'yieldmo',
  S2S = 'S2S'
}

// When we have a bidder here, unskip the returns true if it is an outstreamBidder' test
// in Slot.spec.ts
export enum OutstreamBidder {}

export enum s2sBidder {
  pulsepoint_s2s = 'pulsepoint_s2s',
  districtm_s2s = 'districtm_s2s',
  sovrn_s2s = 'sovrn_s2s',
  appnexus_s2s = 'appnexus_s2s',
  openx_s2s = 'openx_s2s',
  rhythmone_s2s = 'rhythmone_s2s',
  rubicon_s2s = 'rubicon_s2s',
  emx_s2s = 'brealtime_s2s',
  indexExchange_s2s = 'indexExchange_s2s'
}

export enum VideoBidder {
  appnexus = 'appnexus',
  emx = 'emx_digital',
  indexExchange = 'ixVideo',
  oneVideo = 'oneVideo',
  pubmatic = 'pubmatic',
  rubicon = 'rubicon',
  roundel = 'roundel'
}
